import type { FaireProductEntity } from "../../entity_types/product";

export const p_v5rrdanusj: FaireProductEntity = {
  token: "p_v5rrdanusj",
  type: "product",
  name: "Oval Gemstone Worry Stones – Bulk Pocket Crystals",
  brandToken: "b_at4bwf6pjp",
  brandName: "Keystone Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/8a2a7330fe1d589dd3a5fed937aab6b38c2b024ec5c47383d9ad5bc8122b218b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22d62a516d76c7389f94688f14721b3131377fbd92bd7134695b090b29db5b7c.jpeg",
    "https://cdn.faire.com/fastly/548d4b818a0ddc989c2cec8465ff7badc51b1e1ecc6ad492b1ba651c62a3ba2b.jpeg",
    "https://cdn.faire.com/fastly/5fc574e4f987a30bd12427f2e5e3443dfc8b7b6ecbf60c7f4ddd2b50c3bab764.jpeg",
    "https://cdn.faire.com/fastly/802bdaac5371ab9ce80670efe4d8292b9b99260bf7537fb04fab4af1c1d59912.jpeg",
    "https://cdn.faire.com/fastly/3d907718566358425757087671bc20d76932b91853529d763cc3d9cec396a2d2.jpeg",
    "https://cdn.faire.com/fastly/a9ed474871834129647008c66998f2528004d7c38d0c164e814300da159f3527.jpeg",
    "https://cdn.faire.com/fastly/e10256bea7d24965758aa62985455dae22635f8dc6e884321a622a9142e681aa.jpeg",
    "https://cdn.faire.com/fastly/fdd2799bdaa4d160b8ede53570614b3aad7ee4fbbc8055e111be04efa510ddec.jpeg",
    "https://cdn.faire.com/fastly/1dedca7c28b4ffe4146ca93e7e2d66c040f14471c134caf423afd35caf356c0a.jpeg",
    "https://cdn.faire.com/fastly/d220440f60af0e814a588fde118ec9d49f9a6c473f1a7509943ad05cc3aa5b72.jpeg",
    "https://cdn.faire.com/fastly/027f58a65c0a4f1229dec1da44adf16545319affa8e9a3a7fa3e0be5cd381637.jpeg",
    "https://cdn.faire.com/fastly/0bc746b905313ee06c9a2209c89cea71aefa7f9b8764d2d51ee4dd594a29d6a0.jpeg",
    "https://cdn.faire.com/fastly/198ed215cbe05ad4fc5a734a48af90f2a93fadca0e2014e9ec52f45376ae3d83.jpeg",
    "https://cdn.faire.com/fastly/adccf62380191358cddaf91f66a0e5c9123047260a5a9f0e017367d9f868d140.jpeg",
    "https://cdn.faire.com/fastly/c3ca5d03f74586750dde3572f3ca9f679a8d71701e114796bf9076bbaacfa89a.jpeg",
    "https://cdn.faire.com/fastly/c36f6e59e73ffa453344b0d59415e1f963d614cec019e0f4c21e64c4c000f450.jpeg",
    "https://cdn.faire.com/fastly/726532209762a2903914fc339dfc3cf5af9441cc0c8f5da86484fc3474444eb4.jpeg",
    "https://cdn.faire.com/fastly/3f099b0cd3c98b0e3c87d089cf0138eddd6029724b1938b7bff1ffe0d86dd120.jpeg",
    "https://cdn.faire.com/fastly/3d659450ff053db1a4d948186bc982ebc42e80937e54a840d94186a62b1aea7b.jpeg",
    "https://cdn.faire.com/fastly/46fa8c9bc1aefd37d26f9bd13c0225b0c52abdf00cd9af60adbf4ce960bafaf7.jpeg",
    "https://cdn.faire.com/fastly/6c7abe5384f75e6343fde21fcdecea8af4b2426962d019b6d082a2e069227585.jpeg",
    "https://cdn.faire.com/fastly/5577a204d4a4c4c802ad66a87a9c559ccec73142a1927c287e0213f162cb2386.png",
    "https://cdn.faire.com/fastly/493a6e3ac40320802437ade990980aa0d16ab9bb54b69db99e2b3b13c20bf1d2.jpeg",
    "https://cdn.faire.com/fastly/b631ae8e19dfafad052b9cda4b485d13fe85f6db70a829dcabacb64e84682f28.jpeg",
    "https://cdn.faire.com/fastly/a09baa28a0648209794ea7376c44aad62a8e7eaf1419fe2824a362ba1910c692.jpeg",
    "https://cdn.faire.com/fastly/eccbf46d5b632ba95f0dc0f9c278b6b1123c109cd1fee763437ac6692f11d65c.jpeg",
    "https://cdn.faire.com/fastly/764f4980b9d891767289a4b0b405223cacd2598dd49e7167fa08235d728d7e6c.jpeg",
    "https://cdn.faire.com/fastly/d614096626b90d47660b560597510d2573b34530454061880ed42a365cb3bce4.jpeg",
    "https://cdn.faire.com/fastly/4e337eeb8aa4d7f0899de852d51aa7d422d2297a21e87f1fa244823a27b1bdca.jpeg",
  ],
  priceDollars: 3.12,
  description:
    "Support your customers' self-care journey with our Oval Gemstone Worry Stones – pocket-sized crystals crafted for calming the mind and relieving stress. Perfect for crystal retailers, metaphysical shops, holistic boutiques, and gift stores, these worry stones are ideal for resale or inclusion in curated wellness kits. Each stone features a thumb-sized indentation for meditative rubbing, enhancing relaxation and grounding. Available in assorted gemstones and sold in bulk at wholesale pricing. These worry stones are a must-have inventory addition for crystal retailers seeking, affordable, and beautifully crafted gemstone products.\n\nSold individually with a minimum of 2 per style, approximately - H 45mm - W 34mm. \n",
  tags: [],
  msrpDollars: 6.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:25.984Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
